import React, { useMemo } from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import OnePercentModule from './OnePercentModule';
import OnePercent from '../../svg/home/OnePercent';
import Trees from '../../svg/home/Trees';
import NoTrace from '../../svg/home/NoTrace';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { GERMAN, FRENCH } from '../../../utils/constants/language_region_codes';

const {
  strings: {
    HOME_PAGE: {
      ONE_PERCENT_BLOCK: {
        ONE_PERCENT_FOR_THE_PLANET,
        A_PORTION_OF_EVERY,
        TEN_THOUSAND_AND_COUNTING,
        NO_TRACE_ON_THE_TRAIL,
        FROM_OUR_BIRTHDAY,
        AS_A_NO_TRACE_PARTNER,
        GET_PRO_AND_GIVE_BACK,
        GIVE_PRO_AND_GIVE_BACK
      }
    }
  }
} = StringConstantsMixin;

const OnePercentBlock = ({ languageRegionCode, proUser }) => {
  const [ctaUrl, ctaLabel] = useMemo(() => {
    return proUser
      ? ['/gift?ref=homepage_gift_onepercentblock', GIVE_PRO_AND_GIVE_BACK]
      : ['/pro?ref=homepage_pro_onepercentblock', GET_PRO_AND_GIVE_BACK];
  }, [proUser]);

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.modulesContainer}>
          <OnePercentModule className={styles.module} icon={<OnePercent />} title={ONE_PERCENT_FOR_THE_PLANET} text={A_PORTION_OF_EVERY} />
          <OnePercentModule className={styles.module} icon={<Trees />} title={TEN_THOUSAND_AND_COUNTING} text={FROM_OUR_BIRTHDAY} />
          <OnePercentModule className={styles.module} icon={<NoTrace />} title={NO_TRACE_ON_THE_TRAIL} text={AS_A_NO_TRACE_PARTNER} />
        </div>
        <a
          href={LanguageSupportUtil.wrapUrlSafe(ctaUrl, languageRegionCode)} data-test-id="get-pro-and-give-back"
          className={`${styles.ctaLink} ${[GERMAN, FRENCH].includes(languageRegionCode) ? styles.smallCtaText : ''}`}
        >
          {ctaLabel}
        </a>
      </div>
    </div>
  );
};

OnePercentBlock.propTypes = {
  languageRegionCode: string
};

OnePercentBlock.defaultProps = {
  languageRegionCode: 'en-US'
};
export default OnePercentBlock;
